export const API_BASE_URL = process.env.REACT_APP_API_URL;

// Optional but useful
export const BASE_URL = process.env.REACT_APP_API_URL.replace('/api', '');